import { LateralLengthFactorBase } from './base/lateral-length-factor-base';

export class LateralLengthFactor extends LateralLengthFactorBase { }